export const DOCUMENT_TYPES = [
	'IMAGE',
	'MODULE',
	'DOCUMENT',
	'ANSWERS',
	'ANSWER',
	'MEETING_EXPORT',
	'ANSWERS_BASIC_ASSESSMENT',
	'ANSWERS_DETAILED_ASSESSMENT',
] as const;

export type DocumentType = typeof DOCUMENT_TYPES[number];
